<template>
  <div>
    <b-card title="">
      <custom-g-table
        v-if="displayTable"
        ref="custom-table"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :totalRows="totalRows"
        :limit="limit"
        :hasDeleteButton="true"
        :hasUpdateDataButton="true"
        @changePage="onChangePage"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
        @onDelete="onDelete"
        @updateData="updateData"
      />
    </b-card>
    <b-modal>
      <div class="d-block">
        <b-row>
          <b-col md="12">
            <label for="sync-params-logical-number">Origem</label>
            <v-select
              id="sync-params-logical-number"
              placeholder="Selecione um numero logico"
              v-model="syncParamsForm.origin"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :options="origins"
              :tabindex="0"
            >
              <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
            </v-select>
          </b-col>
        </b-row>  
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BRow, BCol } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import dropdownService from "@/providers/dropdownService";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import authTokenService from "@/providers/authTokenService";
import messageDialogHelper from "@/helpers/message-dialog-helper";
import AppConstants from "@/appConstants";
import vSelect from "vue-select";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    CustomGTable,
    BRow,
    BCol,
    vSelect,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filter: {},
      tableLoading: true,
      syncParamsForm: {
        origin: null
      },
      isSyncing: false,
      filterFields: [
        { 
          id: 'filter-origin', 
          placeholder: 'Origem', 
          type: 'list', 
          inputType: '', 
          model: 'origin', 
          list: 'filter-list-origin', 
          array: [] 
        },
      ],
      fields: [
        { 
          field: "action_buttons", 
          label: "Ações", 
          sortable: false },
        {
          field: "email",
          label: "Email",
          sortable: true,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por Email",
            trigger: "enter",
          },
        },
        { 
          field: "origin", 
          label: "Origem", 
          type: "object", 
          sortable: false, 
          filterOptions: { 
            filterValue: '', 
            enabled: true, 
            placeholder: 'Pesquisar por origem',
            filterDropdownItems: [] 
          } 
        },
        {
          field: "dt_create",
          label: "Data de criação",
          type: "custom_date",
          sortable: false
        },
        {
          field: "isDesktop",
          label: "Tipo de dispositivo",
          type: "boolean",
          sortable: false,
          filterOptions: { 
            filterValue: '', 
            enabled: true, 
            placeholder: 'Pesquisar por ativo', 
            filterDropdownItems: [
              {
                value: true, 
                text: 'Desktop'
              }, 
              {
                value: false, 
                text: 'Mobile'
              }
            ] 
          },
          // formatter: (value) => value ? 'Desktop' : 'Mobile'
        },
        {
          field: "device_id",
          label: "Device ID",
          sortable: false,
        },
        {
          field: "auth_system",
          label: "Sistema de Autenticação",
          sortable: false,
        },
        {
          field: "token",
          label: "Token",
          sortable: true,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por token",
            trigger: "enter",
          },
        },
        {
          field: "token_validate",
          label: "Validade do Token",
          type: "custom_date",
          sortable: false
        },
      ],
      origins: [],
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", "Autenticação de Clientes");
    this.loadDataFilter();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }

      return params;
    },
  },
  methods: {
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      dropdownService.getAllOrigin(new URLSearchParams())
      .then(res => {
        const origins = res.map(item => {
          return { value: item.id, text: item.name };
        });
        this.fields[this.fields.findIndex(item => item.field=='origin')].filterOptions.filterDropdownItems = origins;
        this.syncParamsForm.origin = res.find(item => item.code == 250);
        this.setInitialTableFilters();
      })
      .catch(err => console.log(err));
    },
    loadData() {
      this.data = [];
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', authTokenService.getall(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.data = res.data;
          this.totalRows = res.totalRows;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onDelete(data) {
      const params = new URLSearchParams();
      authTokenService
        .deleteToken(data._id, params)
        .then(() => {
          console.log("deleted");
          messageDialogHelper.displayDeleteDataMessage(()=> {
            this.loadData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
    clearFilters() {
      this.fields.forEach(field => {
        if (field.filterOptions && field.filterOptions.filterValue !== undefined) {
          field.filterOptions.filterValue = '';
        }
      });
      const query = { ...this.$route.query };
      Object.keys(query).forEach(key => {
        if (!['page', 'limit', 'lang'].includes(key)) {
          delete query[key];
        }
      });
      this.$router.replace({ query });
      this.$forceUpdate();
    },
    updateData() {
      this.clearFilters();
      this.loadDataFilter();
    }
    
  }
};
</script>